import * as Dialog from "@radix-ui/react-dialog";
import { PrimaryButton } from "@/components/buttons/PrimaryButton";

interface PenaltyScheduleDownloadDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isDownloading: boolean;
}

export const PenaltyScheduleDownloadDialog = ({
  open,
  onOpenChange,
  onConfirm,
  isDownloading,
}: PenaltyScheduleDownloadDialogProps) => {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 z-50" />
        <Dialog.Content className="fixed left-[50%] top-[50%] z-50 w-full max-w-[520px] translate-x-[-50%] translate-y-[-50%] bg-white rounded-2xl shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] focus:outline-none">
          <div className="flex items-start justify-between p-6 pb-4 border-b border-stroke">
            <Dialog.Title className="font-clash-display font-semibold text-[20px] text-[#121212] leading-normal">
              Before you download
            </Dialog.Title>
            <Dialog.Close className="rounded-sm opacity-70 hover:opacity-100 focus:outline-none transition-opacity cursor-pointer shrink-0 mt-0.5">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
                <path d="M18 6L6 18M6 6L18 18" stroke="#404040" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Dialog.Close>
          </div>
          <div className="p-6 flex flex-col gap-y-6">
            <div className="font-clash-display font-normal text-sm text-[#404040] leading-[22px] flex flex-col gap-y-2">
              <p>
                Before uploading this penalty schedule, ensure you have
                downloaded your PSSP's penalty template and copied the necessary
                fields from this penalty schedule into your PSSP's penalty
                template.
              </p>
              <p>
                Ensure penalty amounts are entered in the{" "}
                <span className="font-semibold">Other Contribution Amount</span>{" "}
                field in your schedule.
              </p>
            </div>
            <div className="flex flex-row gap-x-3 justify-end">
              <Dialog.Close asChild>
                <button
                  type="button"
                  className="font-clash-display font-medium text-sm text-[#404040] px-5 py-2.5 rounded-lg border border-stroke hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  Cancel
                </button>
              </Dialog.Close>
              <PrimaryButton
                title="Download"
                isLoading={isDownloading}
                onClick={onConfirm}
                disabled={isDownloading}
              />
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
